<template lang="pug">
.product-group-stat.d-flex.flex-column.h-100.scrollable
  .custom-header.d-flex.sticky-top
    //- CustomTab.flex-fill(
    //-   :tabItems='tabItems'
    //-   v-model='selectedTab'
    //- )
    .px-4.pt-3.pb-3.ml-3.mt-3
      .text-title
        | ลำดับที่ {{ ranking }}
        | {{ productGroup.name }}


    button.transparent-button.no-scaling.ml-auto.mb-auto(@click='$emit(`closeButtonClicked`)')
      i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

  .d-flex.flex-column.px-4.mx-3.pb-4
    .ml-auto.text-right
      .text-medium
        | ยอดขาย
        //- | ไตรมาสที่ 1 ปี 2020
      .text-xlarge.bold
        | {{ productGroup.total | currency }}
    .ml-auto.mt-3
      InputWithIconSlot(
        type='text' placeholder='ค้นหาด้วยชื่อ'
        v-model='filterSearch'
        width='300px'
      )
        i.fa.fa-search

  hr.m-0
  .py-2.px-3
    CustomTable(
      :columns='tableColumns'
      :data='filteredTableData'
      :showIndexes='true'
      @itemClicked='showModal'
    )

  modal(
    name='product-stat'
    width='90%' height='90%'
    transition='modal-transition'
  )
    ProductStat(
      :customer='customer'
      :product='selectedItem'
      :filterDate='filterDate'
      @closeButtonClicked='hideModal'
    )

</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';
import ProductStat from '@/components/history/dialogs/BestSellings/ProductStat.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    productGroup: {
      default: () => ({}),
    },
    ranking: {
      default: '0',
    },
    filterDate: {},
  },
  // computed: {
  //   formattedDate() {
  //     return this.$moment(this.backOrder.date).format('D MMMM YYYY');
  //   },
  //   formattedTime() {
  //     return this.$moment(this.backOrder.time).format('HH:mm');
  //   },
  // },
  computed: {
    filteredTableData() {
      const KEYWORD = this.filterSearch.trim().toUpperCase();
      /* eslint-disable-next-line */
      const res = this.tableData.filter((item) => {
        return (
          // (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate)
          // && (!this.filterStatus || item.status === this.filterStatus)
          (!KEYWORD
            || item.productId.toString().toUpperCase().startsWith(KEYWORD)
            || item.productName.toUpperCase().includes(KEYWORD)
          )
        );
      });
      // res.sort((a, b) => {
      //   switch()
      // })
      return res;
    },
  },
  data: () => ({
    // filterDate: '',
    filterSearch: '',
    // filterStatus: undefined,

    tableData: [],
    tableColumns: {
      // date: {
      //   title: 'วันที่ทำรายการ',
      //   align: 'left',
      //   type: Date,
      // },
      productId: {
        title: 'รหัสสินค้า',
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
      },
      // quantity: {
      //   title: 'จำนวนสินค้า',
      //   align: 'right',
      // },
      // price: {
      //   title: 'ราคาขาย',
      //   align: 'right',
      //   type: Number,
      // },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
      },
    },

    selectedItem: {},
  }),
  methods: {
    async loadData() {
      if (this.productGroup && this.customer) {
        this.isLoading = true;

        // const res = await this.$api.product.categoryStat(this.productGroup.id, this.customer.id);
        // if (res.status === 200) {
        //   this.tableData = res.data.data;
        // }
        this.tableData = this.productGroup.items.map(elm => ({
          ...elm,

          // keeps compatibility with the mockup pages
          productId: elm.product_id ? elm.product_id : elm.productId,
          productName: elm.product_name ? elm.product_name : elm.productName,
          // TODO: add date, quantity, price
        }));

        this.isLoading = false;
      }
    },
    showModal(e) {
      this.selectedItem = e.data;
      this.$modal.show('product-stat');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('product-stat');
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    if (this.customer) {
      this.loadData();
    }
  },
  components: {
    CustomerCompactDetailHeader,
    ProductStat,
  },
};
</script>

<style lang="scss">
// .product-group-stat {}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
